import {Config} from '../Config/Config';

import {store} from '../reducers/index';
import {userActions} from '../Actions/user.actions'
import {decode as base64_decode, encode as base64_encode} from 'base-64';

let retryLogin=0;

export const fetchService = {

    loginByOleconnect,
    loginByOle,
    callbyget,
    callbypost,
    replaceMagicDigit,  
};

const LOGIN_PAGE_KEYWORD_PHRASE = 'action="/names.nsf?Login"';
const SCHEDULE_LOGIN_PAGE_KEYWORD_PHRASE = "The HKMU's Personal Data Protection Policy";
const OLE_LOGIN_SESSION_TIMEOUT_KEYWORD_PHRASE = "guest_login";

function loginByOleconnect(username, password) {

    let dataToSend = {username: username, password: password,redirectto:"https://ole.hkmu.edu.hk/OLEhome?ReadForm"};

    let formBody = [];
    for (let key in dataToSend) {
      let encodedKey = encodeURIComponent(key);
      let encodedValue = encodeURIComponent(dataToSend[key]);
      formBody.push(encodedKey + '=' + encodedValue);
    }
    formBody = formBody.join('&');
    
    const requestOptions = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json','Authorization':'Basic ' + base64_encode( Config.syncAPIUsername+":"+Config.syncAPIPwd) },
        body: JSON.stringify(dataToSend),

    };
    const url=Config.OLECONNECT_LOGIN_URL;

    return fetch(url, requestOptions)
    .then((response)=> handleResponse(response,url,{},dataToSend,true))
    //.then(handleResponse)
    .then((responseJson) => {
        
        if (responseJson.result==1){
            //Alert.alert(responseJson.ltaptoken);
            console.log(responseJson.ltaptoken)

            store.dispatch({type:'SET_USERLTPATOKEN',payload:responseJson.ltaptoken})
            
            return true;
        }else {
            return false;
        }
        
    });
}

function handleResponse(response,url,reqOptions,param,fromPost) {
    return response.text().then(async (text) => {
        let data;
        try{
            // console.log(text);
            text = await checkNeedLoginAgain(text,url,reqOptions,param,fromPost);
            data = text && JSON.parse(trimResponse(text));
            // console.log(text);
            // console.log("data",data);
            //console.log('save cache');
        }catch(e){
        
            const username=(store.getState().userInfo.savedUsername);
                return Promise.reject('JSON invalid');
        }
        
        if (!response.ok) {
            if (response.status === 401) {
                // auto logout if 401 response returned from api
                //logout();
                //location.reload(true);
            }
            //await ErrorLogDBObj.addLog('callBy'+(fromPost?'Post':'Get'),param,url);
            const error = (data && data.message) || response.statusText;
            return Promise.reject(error);
        }
        
        return data;
    });

}



async function loginByOle(username, password) {
    
    let dataToSend = {username: username, password: password,redirectto:'/'};
    
    let formBody = [];
    for (let key in dataToSend) {
      let encodedKey = encodeURIComponent(key);
      let encodedValue = encodeURIComponent(dataToSend[key]);
      formBody.push(encodedKey + '=' + encodedValue);
    }
    formBody = formBody.join('&');
    
    const requestOptions = {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded; charset=utf-8' },
        body: formBody,
        redirect: 'follow',
        //mode: 'no-cors', // no-cors, *cors, same-origin

    };
    
    //Config.OLE_LOGIN_URL
    return fetch(Config.OLE_LOGIN_URL,requestOptions)

        .then(response=>{
            
            return response.text()})
        .then(async (responseText) => {
            
            // store user details and jwt token in local storage to keep user logged in between page refreshes
            console.log(responseText);
            if(responseText.indexOf('have not been recognized')>0||responseText.indexOf('Have you registered?')>0){
                console.log(false);
                return false;
            }else {
                /*
                CookieManager.get('https://ole.hkmu.edu.hk')
                .then((cookies) => {
                    const dispatch = store.dispatch;
                    console.log(cookies['LtpaToken'].value);
                    if (cookies['LtpaToken']){
                        console.log('setLtpaToken');
                    dispatch({
                        type: userConstants.SET_LOGIN_LTPA_TOKEN,    
                        payload:cookies['LtpaToken'].value
                    });
                    
                    }
                });*/
                console.log(true);
                return true
            }
        })
        .catch((e)=>{
            console.log(e); 
        });
}

async function checkNeedLoginAgain(responseText,url,reqOptions,param,fromPost){
    let checkScheduleLogin=false;
    const dispatch = store.dispatch;

    try{
        retryLogin=parseInt(retryLogin);
    }catch(e){
        retryLogin=0;
    }

    if(responseText.indexOf(LOGIN_PAGE_KEYWORD_PHRASE)>-1 || responseText.indexOf(OLE_LOGIN_SESSION_TIMEOUT_KEYWORD_PHRASE)>-1||(checkScheduleLogin&&responseText.indexOf(SCHEDULE_LOGIN_PAGE_KEYWORD_PHRASE)>-1 )){
        
        if ((retryLogin+1)<=2){
            let username;
            let password;
            
                username=(store.getState().userInfo.savedUsername);
                password=store.getState().userInfo.savedPassword;
            
            
            if (username.length&&password.length){
                const reLoginResult=await dispatch(userActions.login(username,password,true));
                if (reLoginResult){
                    
                    if (fromPost){
                        return await callbypost(url,reqOptions,param)
                    }
                    else {
                        return await callbyget(url,reqOptions,param)
                    }
                } //no clear storage
            }else {
                console.log('finish relogin error');
                return false
            }
            
        }else {
            //alert(L('server_connection_fail'));
        }
    }else {
        //await AsyncStorage.setItem('retryLogin', '0')     
        return responseText;
    }
}

function callbypost(url,reqOptions={},param={}) {
    
    //url=replaceMagicDigit(url);
    // 'Content-Type': 'application/json','Authorization':'Basic ' + base64_encode(  'sync_admin:2018_B200F') 
      const requestOptions = {
        method: 'POST',
        //headers: {},
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8'
        },
        body: JSON.stringify(param),
        ...reqOptions
    };
    // console.log(requestOptions);
    return fetch(url, requestOptions)
    .then((response,request)=>{ 
        // console.log(request);
        // console.log("response:",response);
        return handleResponse(response,url,reqOptions,(param=={}?JSON.parse(reqOptions.body):param),true)})
    .then(data => { 
        // console.log("data:",data);
        return data
    }).catch(async (error) => {
        //await ErrorLogDBObj.addLog('callByPost',error + JSON.stringify(param),url);
    });
}

function callbyget(url,reqOptions={},param={}) {
    console.log(url);
    url=replaceMagicDigit(url,param);
    
      const requestOptions = {
        method: 'GET',
        ...reqOptions
    };
    console.log(url);
    console.log(store.getState().userInfo.savedUsername);

    return fetch(url, requestOptions)
    .then((response)=> handleResponse(response,url,reqOptions,param))
    .then(data => {   
        //ErrorLogDBObj.addLog('callByGet','testing',url);
        return data
    })
    .catch(async (error) => {
        //await ErrorLogDBObj.addLog('callByGet',error,url);
    });
   
}


function replaceMagicDigit(_url,param={}){
        
    let username=(store.getState().userInfo.username);
    // if (store.getState().userInfo.isAdmin&&store.getState().userInfo.savedCheckedUser)
    //     username=store.getState().userInfo.savedCheckedUser
    
    if (username.length<5 || isNaN(username.substr(4,1))){            
         _url = _url.replace('[MAGIC_DIGIT]', 'A' );
    }        
    else {
         _url = _url.replace('[MAGIC_DIGIT]', username.substr(4,1) );            
    } 
    
    _url = _url.replace('[USER_ID]', username );
    
    
    for (var i in param){
        _url = _url.replace('['+i.toUpperCase()+']',param[i])
    }
    var sign=_url.indexOf("?")>-1?"&":"?";
    
    var appSign='';
    _url = _url+sign+appSign;
    
    return _url;        
}  

function trimResponse(responseTxt){
    responseTxt=responseTxt||'{}';
    responseTxt=responseTxt.trim();
    if (responseTxt.substr(0,1)=="(" && responseTxt.substr(responseTxt.length-1,1)==")"){
        return responseTxt.substr(1,responseTxt.length-2);
    }
    else return responseTxt;
}